import { ApiError, TimeoutError } from './client';

/// Translate any error thrown by an `api/` call into a one-line message a
/// user can act on. The four exit paths are intentionally distinct so the
/// UI tells the caller *what* failed (server-rejected vs. timeout vs.
/// network vs. unknown) without leaking stack traces.
///
/// `fallback` is shown for unrecognized error shapes — callers can override
/// it when the surrounding surface has a more specific phrasing
/// ("Cancel timed out", "Failed to schedule deletion", etc.).
export function apiErrorMessage(
  err: unknown,
  fallback = 'Something went wrong. Please try again.',
): string {
  if (err instanceof ApiError) return err.message;
  if (err instanceof TimeoutError) {
    return 'The server took too long to respond. Please try again.';
  }
  // `fetch` surfaces network-level failures (DNS, TCP reset, TLS, CORS) as
  // a bare `TypeError`. Catch it here so we don't show users a generic
  // "Something went wrong" when the real problem is that they're offline.
  if (err instanceof TypeError) {
    return 'Network error. Check your connection and try again.';
  }
  return fallback;
}
